export default "__VITE_ASSET__dc82179a__"